// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__zxQPb","image":"Header_image__2zJmi","name":"Header_name__2nGN7","info":"Header_info__3DOLu","infoRow":"Header_infoRow__3gcdJ"};